// extracted by mini-css-extract-plugin
export default {"welcome-message":"WelcomeMessage_welcome-message__wpHWO"};